import { Report } from "./Report.js";
export function createReport(entry) {
    return new Report([entry]);
}
//# sourceMappingURL=createReport.js.map